import { useL10n } from "@ews/react-localization-context";
import
{
    IonButton,
    IonItem,
    IonLabel
} from "@ionic/react";
import React, { useState } from "react";
import { useModifyUserNotifications, useUser, useUserNotifications } from "../../../ReactData/user";
import { useIsMobile } from "../../../Responsive";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import SettingsTableRow from "../../../Settings/SettingsComponents/SettingsTable/SettingsRow/SettingsTableRow";
import SettingsTableColumn from "../../../Settings/SettingsComponents/SettingsTable/SettingsTableColumn/SettingsTableColumn";
import SettingsTableGrid from "../../../Settings/SettingsComponents/SettingsTable/SettingsTableGrid/SettingsTableGrid";
import PushOption from "./Components/Options/Options";

import { PushSettingsProps } from "./types";

import { PushCategory } from "@ews/zlt-events";

import
{
    NotificationChannel,
    UserNotifications,
    UserTTSPreferences,
    permissionAllowed,
    setNotificationChannel,
    unsetNotificationChannel
} from "@ews/react-data";
import { useMyPermissions, useMyProfileId } from "../../../Login/LoginProvider";
import { useInvokeTestPush } from "../../../ReactData/rpc";

const toggleBit = (target: number, bit: number, state: boolean) => state ? (target | bit) : (target & ~bit);

const PushSettings: React.FC<PushSettingsProps> = ({ id }) =>
{
    const user = useUser(id);
    const userNotification = useUserNotifications(id);

    const modifyNotification = useModifyUserNotifications();

    const { translate: t } = useL10n();
    const mobileView = useIsMobile();
    const myPermissions = useMyPermissions();
    const myId = useMyProfileId();
    const allowedToEdit = myId === id ? true : permissionAllowed(myPermissions.createUser || 0);

    const [speechToText, setSpeechToText] = useState<boolean>(false);

    const invokeTestPush = useInvokeTestPush();

    //const columnMargin = { margin: '5px 0' };
    const updateNotification = async (data: UserNotifications) =>
    {
        await modifyNotification(user.id!, data);
    };
    const titlePosition = mobileView ? { textAlign: 'center' } : { textAlign: 'left', verticalAlign: 'sub' };
    const childPosition = { marginLeft: '20px', fontStyle: 'italic', fontSize: 'medium !important' };

    const sizeMainCol = mobileView ? "12" : "6";
    const sizeSoundCol = "3";
    const otherCols = "1";
    function setValues(status: boolean)
    {
        const fn = status ? setNotificationChannel : unsetNotificationChannel;

        return {
            technicalMessageSilent: fn(userNotification.technicalMessageSilent || 0, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
            fireAlarm: fn(userNotification.fireAlarm, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
            fireAlert: fn(userNotification.fireAlert, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
            preAlarm: fn(userNotification.preAlarm, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
            testScenario: fn(userNotification.testScenario, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
            testCondition: fn(userNotification.testCondition, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
            testActivation: fn(userNotification.testActivation, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
            testAlarm: fn(userNotification.testAlarm, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
            activeOutput: fn(userNotification.activeOutput, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
            fault: fn(userNotification.fault, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
            technicalMessage: fn(userNotification.technicalMessage, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
            disablement: fn(userNotification.disablement, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
            extinguishingEvent: fn(userNotification.extinguishingEvent, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
            status: fn(userNotification.status, NotificationChannel.PUSH | NotificationChannel.PUSH_END),
        };
    }

    function onClickTestPush(pushCategory: PushCategory)
    {
        if (!user?.id) {
            console.error("onClickTestPush: user.id is undefined. This should not be possible. Calling invokeTestPush skipped.");
            return;
        }
        console.debug(`Test push an: ${PushCategory[pushCategory]} === ${pushCategory}`);
        invokeTestPush({
            userId: user.id,
            pushCategory,
        });
    }

    return <>
        <SettingsCol size={sizeMainCol} xl={sizeMainCol} md={sizeMainCol} lg={sizeMainCol}>

            <SettingsTableGrid>
                <SettingsTableRow hidden={mobileView}>
                    <SettingsTableColumn size="4" center={false}>
                        <IonLabel style={{ margin: 0 }}>{`${t('[SID_MNU_HK_ONE_EVENT]')}:`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn size={otherCols}>
                        <IonLabel style={{ textAlign: "center", margin: 0 }}>{`${t('[REACT_BEGIN]')}:`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn size={otherCols}>
                        <IonLabel style={{ textAlign: "center", margin: 0 }}>{`${t('COM_FACPMANAGEMENT_END_EVENT')}:`}</IonLabel>
                    </SettingsTableColumn>
                    {/* <SettingsTableColumn size={otherCols}>
                        <IonLabel style={{ textAlign: "center", margin: 0 }}>{`${t('COM_FACPMANAGEMENT_USER_ACCOUNT_NOTIFICATIONS_EVENTS_PRIORITY')}:`}</IonLabel>
                    </SettingsTableColumn> */}
                    <SettingsTableColumn size={sizeSoundCol}>
                        <IonLabel style={{ textAlign: "center", margin: 0 }}>{`${t('[REACT_SOUND]')}:`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn size={otherCols}>
                        <IonLabel style={{ textAlign: "center", margin: 0 }}>{`${t('[REACT_TEST_PUSH]')}:`}</IonLabel>
                    </SettingsTableColumn>

                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_MNU_TAB_ALARMS]"//[SID_MNU_TAB_ALARMS]
                        size={otherCols}
                        options={{
                            push: "begin",
                            push_end: "end",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.fireAlarm || 0}
                        sound={userNotification.fireAlarmSound}
                        sizeSoundCol={sizeSoundCol}
                        onChange={(fireAlarm) => updateNotification({ fireAlarm } as UserNotifications)}
                        onSelect={(fireAlarmSound) => updateNotification({ fireAlarmSound: `${fireAlarmSound}` } as UserNotifications)}
                        pushCategory={PushCategory.FireAlarm}
                        onClickTestPush={onClickTestPush}
                    />
                </SettingsTableRow>

                <SettingsTableRow>

                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_DEV_STATE_PREALARM]"
                        size={otherCols}
                        options={{
                            push: "begin",
                            push_end: "end",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.preAlarm || 0}
                        sound={userNotification.preAlarmSound}
                        sizeSoundCol={sizeSoundCol}
                        onChange={(preAlarm) => updateNotification({ preAlarm } as UserNotifications)}
                        onSelect={(preAlarmSound) => updateNotification({ preAlarmSound: `${preAlarmSound}` } as UserNotifications)}
                        pushCategory={PushCategory.PreAlarm}
                        onClickTestPush={onClickTestPush}
                    />
                </SettingsTableRow>

                <SettingsTableRow>

                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_EV_FIRE_PREALARM_SH]"
                        size={otherCols}
                        options={{
                            push: "begin",
                            push_end: "end",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.fireAlert || 0}
                        sound={userNotification.fireAlertSound}
                        sizeSoundCol={sizeSoundCol}
                        onChange={(fireAlert) => updateNotification({ fireAlert } as UserNotifications)}
                        onSelect={(fireAlertSound) => updateNotification({ fireAlertSound: `${fireAlertSound}` } as UserNotifications)}
                        pushCategory={PushCategory.FireAlert}
                        onClickTestPush={onClickTestPush}
                    />
                </SettingsTableRow>

                <SettingsTableRow>

                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_ONE_TEST_ALARM]"
                        size={otherCols}
                        options={{
                            push: "begin",
                            push_end: "",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.testScenario || 0}
                        sound={userNotification.testScenarioSound}
                        sizeSoundCol={sizeSoundCol}
                        onChange={(testScenario) =>
                        {
                            updateNotification({ testScenario } as UserNotifications);
                        }}
                        onSelect={(testScenarioSound) => updateNotification({ testScenarioSound: `${testScenarioSound}` } as UserNotifications)}
                        pushCategory={PushCategory.TestAlarm} // TODO: is PushCategory.TestAlarm correct here? How does userNotification.testScenario map to PushCategory?
                        onClickTestPush={onClickTestPush}
                    />
                </SettingsTableRow>


                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={mobileView ? titlePosition : childPosition}
                        center={false}
                        label="[SID_EV_TECHN_MESS_TEST_COND_SH]"
                        size={otherCols}
                        options={{
                            push: "begin",
                            push_end: "",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.testCondition || 0}

                        onChange={(testCondition) =>
                        {
                            updateNotification({ testCondition } as UserNotifications);

                        }}
                    />
                </SettingsTableRow>



                <SettingsTableRow
                //hidden={ }
                >

                    <PushOption
                        disabled={!allowedToEdit}
                        style={mobileView ? titlePosition : childPosition}
                        center={false}
                        label="[SID_ONE_TEST_ALARM]"
                        size={otherCols}

                        options={{
                            push: "begin",
                            push_end: "",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.testAlarm || 0}

                        onChange={(testAlarm) =>
                        {

                            updateNotification({ testAlarm } as UserNotifications);
                        }}
                    />

                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={mobileView ? titlePosition : childPosition}
                        center={false}
                        label="[SID_DEV_STATE_TEST_ACTIVE]"
                        size={otherCols}

                        options={{
                            push: "begin",
                            push_end: "",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.testActivation || 0}

                        onChange={(testActivation) =>
                        {

                            updateNotification({ testActivation } as UserNotifications);
                        }}
                    />
                </SettingsTableRow>

                <SettingsTableRow >
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_MNU_TAB_ACT_OUTP]"
                        size={otherCols}
                        options={{
                            push: "begin",
                            push_end: "",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.activeOutput || 0}
                        sound={userNotification.activeOutputSound}
                        sizeSoundCol={sizeSoundCol}
                        onChange={(activeOutput) => updateNotification({ activeOutput } as UserNotifications)}
                        onSelect={(activeOutputSound) => updateNotification({ activeOutputSound: `${activeOutputSound}` } as UserNotifications)}
                        pushCategory={PushCategory.ActiveOutput}
                        onClickTestPush={onClickTestPush}
                    />
                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        style={mobileView ? titlePosition : childPosition}
                        center={false}
                        label="[REACT_SILENCT_ACTUATIONS]"
                        size={otherCols}
                        disabled={allowedToEdit ? !(userNotification.activeOutput & NotificationChannel.PUSH || userNotification.activeOutput & NotificationChannel.PUSH_END) : true}
                        options={{
                            push: "begin",
                            push_end: "",
                            //prioritat: "priorität"
                        }}
                        value={Number(userNotification.activeOutputSilent)}
                        onChange={(activeOutputSilent) => updateNotification({ activeOutputSilent: Boolean(activeOutputSilent) } as UserNotifications)}
                    />
                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_MNU_TAB_FAULTS]"
                        size={otherCols}
                        options={{
                            push: "begin",
                            push_end: "end",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.fault || 0}
                        sound={userNotification.faultSound}
                        sizeSoundCol={sizeSoundCol}
                        onChange={(fault) => updateNotification({ fault } as UserNotifications)}
                        onSelect={(faultSound) => updateNotification({ faultSound: `${faultSound}` } as UserNotifications)}
                        pushCategory={PushCategory.Fault}
                        onClickTestPush={onClickTestPush}

                    />
                </SettingsTableRow>

                <SettingsTableRow >
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_EV_TECHN_MESS_ALARM]"
                        size={otherCols}
                        options={{
                            push: "begin",
                            push_end: "end",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.technicalMessage || 0}
                        sound={userNotification.technicalMessageSound}
                        sizeSoundCol={sizeSoundCol}
                        onChange={(technicalMessage) => updateNotification({ technicalMessage } as UserNotifications)}
                        onSelect={(technicalMessageSound) => updateNotification({ technicalMessageSound: `${technicalMessageSound}` } as UserNotifications)}
                        pushCategory={PushCategory.TechnicalMessage}
                        onClickTestPush={onClickTestPush}
                    />
                </SettingsTableRow>

                <SettingsTableRow>


                    <PushOption
                        style={mobileView ? titlePosition : childPosition}
                        center={false}
                        label="PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_TECHMESS_SILENT"
                        size={otherCols}//todo
                        disabled={allowedToEdit ? !(userNotification.technicalMessage & NotificationChannel.PUSH) : true}
                        options={{
                            push: "begin",
                            push_end: "end",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.technicalMessageSilent || 0}
                        onChange={(technicalMessageSilent) => updateNotification({ technicalMessageSilent } as UserNotifications)}
                    />
                </SettingsTableRow>

                <SettingsTableRow>


                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_MNU_TAB_DISABLEMENTS]"
                        size={otherCols}
                        options={{
                            push: "begin",
                            push_end: "end",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.disablement || 0}
                        sound={userNotification.disablementSound}
                        sizeSoundCol={sizeSoundCol}
                        onChange={(disablement) => updateNotification({ disablement } as UserNotifications)}
                        onSelect={(disablementSound) => updateNotification({ disablementSound: `${disablementSound}` } as UserNotifications)}
                        pushCategory={PushCategory.Disablement}
                        onClickTestPush={onClickTestPush}
                    />
                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_MNU_TAB_EXT_EV]"
                        size={otherCols}
                        options={{
                            push: "begin",
                            push_end: "end",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.extinguishingEvent || 0}
                        sound={userNotification.extinguishingEventSound}
                        sizeSoundCol={sizeSoundCol}
                        onChange={(extinguishingEvent) => updateNotification({ extinguishingEvent } as UserNotifications)}
                        onSelect={(extinguishingEventSound) => updateNotification({ extinguishingEventSound: `${extinguishingEventSound}` } as UserNotifications)}
                        pushCategory={PushCategory.ExtinguishingEvent}
                        onClickTestPush={onClickTestPush}
                    />
                </SettingsTableRow>

                <SettingsTableRow>

                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_MNU_TAB_STATUS]"
                        size={otherCols}
                        options={{
                            push: "begin",
                            push_end: "end",
                            //prioritat: "priorität"
                        }}
                        value={userNotification.status || 0}
                        sound={userNotification.statusSound}
                        sizeSoundCol={sizeSoundCol}
                        onChange={(status) => updateNotification({ status } as UserNotifications)}
                        onSelect={(statusSound) => updateNotification({ statusSound: `${statusSound}` } as UserNotifications)}
                        pushCategory={PushCategory.Status}
                        onClickTestPush={onClickTestPush}
                    />
                </SettingsTableRow>
            </SettingsTableGrid>
            <IonItem lines="none">
                <div style={{ width: "100%" }}>
                    <IonButton
                        disabled={!allowedToEdit}
                        color={"success"}
                        expand={"full"}
                        onClick={() =>
                        {
                            const allValues = {
                                ...setValues(true),
                                activeOutputSilent: true,
                            };
                            updateNotification(allValues as UserNotifications);

                        }}>{t("TD_GROSS_ALLE")}</IonButton>
                </div>
            </IonItem>
            <IonItem>
                <div style={{ width: "100%" }}>
                    <IonButton
                        disabled={!allowedToEdit}
                        color={"danger"}
                        expand={"full"}
                        onClick={() =>
                        {
                            const defaultValues = {
                                ...setValues(false),
                                fireAlarmSound: 'default',
                                fireAlertSound: 'default',
                                preAlarmSound: 'default',
                                testScenarioSound: 'default',
                                activeOutputSound: 'default',
                                activeOutputSilent: false,
                                faultSound: 'default',
                                technicalMessageSound: 'default',
                                disablementSound: 'default',
                                extinguishingEventSound: 'default',
                                statusSound: 'default',
                            };
                            updateNotification(defaultValues as UserNotifications);

                        }}>{t("TPL_BEEZ3_RESET")}</IonButton>
                </div>
            </IonItem>

        </SettingsCol >

        <SettingsCol>
            <SettingsCheckbox
                text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_TTS"}
                checked={Boolean(userNotification.ttsPreferences & UserTTSPreferences.ENABLE)}
                disabled={!allowedToEdit}
                onChange={(checked) =>
                {
                    let { ttsPreferences } = userNotification;
                    ttsPreferences = toggleBit(ttsPreferences, UserTTSPreferences.ENABLE, checked);

                    updateNotification({ ttsPreferences } as UserNotifications);
                }}>

                <SettingsCheckbox
                    text={"COM_FACPMANAGEMENT_SHARES_ANLAGENNAME"}
                    checked={Boolean(userNotification.ttsPreferences & UserTTSPreferences.SYSTEM_NAME)}
                    disabled={!allowedToEdit}
                    onChange={(checked) =>
                    {
                        let { ttsPreferences } = userNotification;
                        ttsPreferences = toggleBit(ttsPreferences, UserTTSPreferences.SYSTEM_NAME, checked);
                        updateNotification({ ttsPreferences } as UserNotifications);
                    }} />
                <SettingsCheckbox
                    text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_DETAILS_LOGICALNUMBER"}
                    checked={Boolean(userNotification.ttsPreferences & UserTTSPreferences.LOGICAL_ADDRESS)}
                    disabled={!allowedToEdit}
                    onChange={(checked) =>
                    {
                        let { ttsPreferences } = userNotification;
                        ttsPreferences = toggleBit(ttsPreferences, UserTTSPreferences.LOGICAL_ADDRESS, checked);
                        updateNotification({ ttsPreferences } as UserNotifications);
                    }} />
                <SettingsCheckbox
                    text={"TD_EREIGNISTEXT"}
                    checked={Boolean(userNotification.ttsPreferences & UserTTSPreferences.EVENT_TEXT)}
                    disabled={!allowedToEdit}
                    onChange={(checked) =>
                    {
                        let { ttsPreferences } = userNotification;
                        ttsPreferences = toggleBit(ttsPreferences, UserTTSPreferences.EVENT_TEXT, checked);
                        updateNotification({ ttsPreferences } as UserNotifications);
                    }} />
                <SettingsCheckbox
                    text={"COM_FACPMANAGEMENT_LOGS_MAIL_TIMESTAMP_EVENT"}
                    checked={Boolean(userNotification.ttsPreferences & UserTTSPreferences.TIMESTAMP)}
                    disabled={!allowedToEdit}
                    onChange={(checked) =>
                    {
                        let { ttsPreferences } = userNotification;
                        ttsPreferences = toggleBit(ttsPreferences, UserTTSPreferences.TIMESTAMP, checked);
                        updateNotification({ ttsPreferences } as UserNotifications);
                    }} />
                <SettingsCheckbox
                    text={"[SID_DLG_TXT_TEXT1]"}
                    checked={Boolean(userNotification.ttsPreferences & UserTTSPreferences.GROUP_TEXT)}
                    disabled={!allowedToEdit}
                    onChange={(checked) =>
                    {
                        let { ttsPreferences } = userNotification;
                        ttsPreferences = toggleBit(ttsPreferences, UserTTSPreferences.GROUP_TEXT, checked);
                        updateNotification({ ttsPreferences } as UserNotifications);
                    }} />
                <SettingsCheckbox
                    text={"[SID_DLG_TXT_TEXT2]"}
                    checked={Boolean(userNotification.ttsPreferences & UserTTSPreferences.ELEMENT_TEXT)}
                    disabled={!allowedToEdit}
                    onChange={(checked) =>
                    {
                        let { ttsPreferences } = userNotification;
                        ttsPreferences = toggleBit(ttsPreferences, UserTTSPreferences.ELEMENT_TEXT, checked);
                        updateNotification({ ttsPreferences } as UserNotifications);
                    }} />

            </SettingsCheckbox>

        </SettingsCol>
        {/*
        <SettingsCol>

                        <SettingsSelect startText="Tone at " text={"[SID_ONE_FIRE_ALARM]"} value={fireAlarm.option} onSelect={(value) => fireAlarm.option = value}>
                            <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_DEFAULT"} value={"default"} />
                            <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIREALARM_RISING"} value={"sawtooth"} />
                            <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_SMOKE_DETECTOR_FIRE_LOOP"} value={"beep"} />
                            <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIRE_ALARM_BEEPING_IN_TRIPLETS"} value={"triple beep"} />
                            <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_CLOCK_RINGING_AND_SHUT_OFF"} value={"bell"} />
                            <SettingsSelectOption text={"COM_CONTENT_NONE"} value={"none"} />
                        </SettingsSelect>

            <SettingsSelect startText="Tone at " text={"Pre-alarm"} value={preAlarm.option} onSelect={(value) => preAlarm.option = value}>
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_DEFAULT"} value={"default"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIREALARM_RISING"} value={"sawtooth"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_SMOKE_DETECTOR_FIRE_LOOP"} value={"beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIRE_ALARM_BEEPING_IN_TRIPLETS"} value={"triple beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_CLOCK_RINGING_AND_SHUT_OFF"} value={"bell"} />
                <SettingsSelectOption text={"COM_CONTENT_NONE"} value={"none"} />
            </SettingsSelect>

            <SettingsSelect startText="Tone at " text={"Fire pre-warning"} value={firePreWarning.option} onSelect={(value) => firePreWarning.option = value}>
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_DEFAULT"} value={"default"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIREALARM_RISING"} value={"sawtooth"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_SMOKE_DETECTOR_FIRE_LOOP"} value={"beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIRE_ALARM_BEEPING_IN_TRIPLETS"} value={"triple beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_CLOCK_RINGING_AND_SHUT_OFF"} value={"bell"} />
                <SettingsSelectOption text={"COM_CONTENT_NONE"} value={"none"} />
            </SettingsSelect>

            <SettingsSelect startText="Tone at " text={"[SID_ONE_TEST_ALARM]"} value={mainTestAlarm.option} onSelect={(value) => mainTestAlarm.option = value}>
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_DEFAULT"} value={"default"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIREALARM_RISING"} value={"sawtooth"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_SMOKE_DETECTOR_FIRE_LOOP"} value={"beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIRE_ALARM_BEEPING_IN_TRIPLETS"} value={"triple beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_CLOCK_RINGING_AND_SHUT_OFF"} value={"bell"} />
                <SettingsSelectOption text={"COM_CONTENT_NONE"} value={"none"} />
            </SettingsSelect>

            <SettingsSelect startText="Tone at " text={"COM_FACPMANAGEMENT_PHONES_AE"} value={activeOutput.option} onSelect={(value) => activeOutput.option = value}>
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_DEFAULT"} value={"default"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIREALARM_RISING"} value={"sawtooth"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_SMOKE_DETECTOR_FIRE_LOOP"} value={"beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIRE_ALARM_BEEPING_IN_TRIPLETS"} value={"triple beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_CLOCK_RINGING_AND_SHUT_OFF"} value={"bell"} />
                <SettingsSelectOption text={"COM_CONTENT_NONE"} value={"none"} />
            </SettingsSelect>

            <SettingsSelect startText="Tone at " text={"COM_FACPMANAGEMENT_PHONES_FAULTS"} value={fault.option} onSelect={(value) => fault.option = value}>
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_DEFAULT"} value={"default"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIREALARM_RISING"} value={"sawtooth"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_SMOKE_DETECTOR_FIRE_LOOP"} value={"beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIRE_ALARM_BEEPING_IN_TRIPLETS"} value={"triple beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_CLOCK_RINGING_AND_SHUT_OFF"} value={"bell"} />
                <SettingsSelectOption text={"COM_CONTENT_NONE"} value={"none"} />
            </SettingsSelect>

            <SettingsSelect startText="Tone at " text={"COM_FACPMANAGEMENT_PHONES_TECHMESS"} value={technicalMessage.option} onSelect={(value) => technicalMessage.option = value}>
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_DEFAULT"} value={"default"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIREALARM_RISING"} value={"sawtooth"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_SMOKE_DETECTOR_FIRE_LOOP"} value={"beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIRE_ALARM_BEEPING_IN_TRIPLETS"} value={"triple beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_CLOCK_RINGING_AND_SHUT_OFF"} value={"bell"} />
                <SettingsSelectOption text={"COM_CONTENT_NONE"} value={"none"} />
            </SettingsSelect>

            <SettingsSelect startText="Tone at " text={"[SID_MNU_TAB_DISABLEMENTS]"} value={disablement.option} onSelect={(value) => disablement.option = value}>
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_DEFAULT"} value={"default"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIREALARM_RISING"} value={"sawtooth"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_SMOKE_DETECTOR_FIRE_LOOP"} value={"beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIRE_ALARM_BEEPING_IN_TRIPLETS"} value={"triple beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_CLOCK_RINGING_AND_SHUT_OFF"} value={"bell"} />
                <SettingsSelectOption text={"COM_CONTENT_NONE"} value={"none"} />
            </SettingsSelect>

            <SettingsSelect startText="Tone at " text={"[SID_MNU_TAB_EXT_EV]"} value={extinguishingEvent.option} onSelect={(value) => extinguishingEvent.option = value}>
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_DEFAULT"} value={"default"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIREALARM_RISING"} value={"sawtooth"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_SMOKE_DETECTOR_FIRE_LOOP"} value={"beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIRE_ALARM_BEEPING_IN_TRIPLETS"} value={"triple beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_CLOCK_RINGING_AND_SHUT_OFF"} value={"bell"} />
                <SettingsSelectOption text={"COM_CONTENT_NONE"} value={"none"} />
            </SettingsSelect>

            <SettingsSelect startText="Tone at " text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_OFFLINE"} value={online.option} onSelect={(value) => online.option = value}>
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_DEFAULT"} value={"default"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIREALARM_RISING"} value={"sawtooth"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_SMOKE_DETECTOR_FIRE_LOOP"} value={"beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_FIRE_ALARM_BEEPING_IN_TRIPLETS"} value={"triple beep"} />
                <SettingsSelectOption text={"PLG_USER_PROFILE_LST_FIELD_NOTIFICATION_SOUND_ALARM_CLOCK_RINGING_AND_SHUT_OFF"} value={"bell"} />
                <SettingsSelectOption text={"COM_CONTENT_NONE"} value={"none"} />
            </SettingsSelect>

        </SettingsCol> */}
    </>;
};

export default PushSettings;
